import React from 'react';
import { View } from 'react-native';
import { useThemedStyles } from '../../hooks/useThemedStyles';

import Switch from './Switch';
import Text from '../text/Text';

const SwitchWithLabel = ({ label, value, onValueChange, required = false, disabled = false }) =>  {
	const styles = useThemedStyles(createStyles);

	// Full width 'settings-style' switch with label
	return (
		<View style={styles.container}>
			<Text style={[styles.label, disabled && styles.labelDisabled]}>
				{label}
				{required && <Text style={styles.required}> *</Text>}
			</Text>
			<View style={styles.switchWrapper}>
				<Switch
					value={value}
					onValueChange={onValueChange}
					disabled={disabled}
					accessibilityLabel={typeof label === 'string' ? label : undefined}
				/>
			</View>
		</View>
	);
};

const createStyles = ({ ui: { colors, touch, type } }) => ({
	container: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		minHeight: touch.min,
		paddingTop: 8,
		paddingBottom: 8,
	},
	label: {
		...type.rowText,
		color: colors.text,
		flex: 1,
		marginRight: 12,
		flexWrap: 'wrap',
	},
	labelDisabled: {
		color: colors.disabledText,
	},
	required: {
		color: colors.danger,
	},
	switchWrapper: {
		alignItems: 'flex-end',
		justifyContent: 'center',
	},
});

export default SwitchWithLabel;
